import React, { useState, useEffect } from "react";
import { applyLeave, getAllLeaves, GetBalanceLeaveByLeaveTypeId } from "../../api/leavesApi";
import { useNavigate } from "react-router-dom";

const ApplyLeave = () => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveBalance, setLeaveBalance] = useState(0);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    employeeCode: sessionStorage.getItem("username") || "",
    leaveTypeID: "",
    startDate: "",
    endDate: "",
    reason: null,
    crUser: sessionStorage.getItem("username") || "admin",
    crDate: new Date().toISOString(),
    deleted: "N",
  });

  // Fetch leave types on mount
  useEffect(() => {
    const empCode = sessionStorage.getItem("employeeCode");
    if (empCode) {
      setFormData((prev) => ({ ...prev, employeeCode: empCode }));
    }

    fetchLeaveTypes();
  }, []);

  const fetchLeaveTypes = async () => {
    try {
      const result = await getAllLeaves();
      setLeaveTypes(result || []);
    } catch (error) {
      console.error("Error fetching leave types:", error);
    }
  };

  // Fetch leave balance whenever leaveTypeID or startDate changes
  useEffect(() => {
    const fetchBalance = async () => {
      if (formData.leaveTypeID) {
        try {
          const year = formData.startDate
            ? new Date(formData.startDate).getFullYear()
            : new Date().getFullYear();
          const balance = await GetBalanceLeaveByLeaveTypeId(
            formData.employeeCode,
            parseInt(formData.leaveTypeID, 10),
            year
          );
          setLeaveBalance(balance);
        } catch (error) {
          console.error("Error fetching leave balance:", error);
          setLeaveBalance(0);
        }
      } else {
        setLeaveBalance(0);
      }
    };

    fetchBalance();
  }, [formData.leaveTypeID, formData.startDate]);

  // Calculate requested days
  const getRequestedDays = () => {
    if (!formData.startDate || !formData.endDate) return 0;
    const start = new Date(formData.startDate);
    const end = new Date(formData.endDate);
    const diffTime = end - start;
    return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1; // inclusive
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestedDays = getRequestedDays();

    // Prevent leave if requested days exceed balance
    if (requestedDays > leaveBalance) {
      alert(`❌ You cannot apply for ${requestedDays} day(s). Available balance is ${leaveBalance}.`);
      return;
    }

    const finalPayload = {
      ...formData,
      leaveTypeID: parseInt(formData.leaveTypeID, 10),
      crDate: new Date().toISOString(),
    };

    console.log("Submitting leave:", finalPayload);

    const result = await applyLeave(finalPayload);
    if (result) {
      alert("✅ Leave applied successfully!");
      setFormData({
        employeeCode: sessionStorage.getItem("username") || "",
        leaveTypeID: "",
        startDate: "",
        endDate: "",
        reason: null,
        crUser: sessionStorage.getItem("username") || "admin",
        crDate: new Date().toISOString(),
        deleted: "N",
      });
      setLeaveBalance(0); // reset balance
    }
  };

  return (
    <div className="container mt-4">
      {/* <h4 className="mb-3">Apply for Leave</h4>
        <div>
          <button className="btn btn-primary btn-sm" onClick={() => navigate("appliedleavelist")}>
            View Leave Details
          </button>
        </div> */}
        <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="allowance-heading mb-0">Apply for Leave</h4>
        
        <button className="btn btn-primary btn-sm" onClick={() => navigate("appliedleavelist")}>
            View Leave Details
          </button>
      </div>

      <form onSubmit={handleSubmit} className="card p-3 shadow-sm">
        {/* EmployeeCode is hidden but still sent */}
        <input type="hidden" name="employeeCode" value={formData.employeeCode} />

        {/* Leave Type dropdown */}
        <div className="mb-3">
          <label>Leave Type </label>
          <select
            name="leaveTypeID"
            className="form-control"
            value={formData.leaveTypeID}
            onChange={handleChange}
            required
          >
            <option value="">-- Select Leave Type --</option>
            {leaveTypes.map((leave) => (
              <option key={leave.leaveTypeID} value={leave.leaveTypeID}>
                {leave.leaveName}
              </option>
            ))}
          </select>

          {formData.leaveTypeID && (
            <small
              className={`text-muted ${
                getRequestedDays() > leaveBalance ? "text-danger" : ""
              }`}
            >
              Available: {leaveBalance} | Requested: {getRequestedDays()}
            </small>
          )}
        </div>

        <div className="mb-3">
          <label>Start Date</label>
          <input
            type="date"
            name="startDate"
            className="form-control"
            value={formData.startDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>End Date</label>
          <input
            type="date"
            name="endDate"
            className="form-control"
            value={formData.endDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Reason</label>
          <textarea
            name="reason"
            className="form-control"
            value={formData.reason}
            onChange={handleChange}
          ></textarea>
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Apply Leave
        </button>
      </form>
    </div>
  );
};

export default ApplyLeave;






// import React, { useState, useEffect } from "react";
// import { applyLeave, getAllLeaves } from "../../api/leavesApi";

// const ApplyLeave = () => {

//   const [leaveTypes, setLeaveTypes] = useState([]);
//   const [formData, setFormData] = useState({
//     employeeCode: sessionStorage.getItem("username") || "",
//     leaveTypeID: "",
//     startDate: "",
//     endDate: "",
//     reason: null,
//     crUser: sessionStorage.getItem("username") || "admin",
//     crDate: new Date().toISOString(),
//     deleted: "N",
//   });

//   useEffect(() => {
//     const empCode = sessionStorage.getItem("username");
//     if (empCode) {
//       setFormData((prev) => ({ ...prev, employeeCode: empCode }));
//     }

//     fetchLeaveTypes();
//   }, []);

//   const fetchLeaveTypes = async () => {
//     try {
//       const result = await getAllLeaves();
//       setLeaveTypes(result || []);
//     } catch (error) {
//       console.error("Error fetching leave types:", error);
//     }
//   };


//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   const finalPayload = {
//     ...formData,
//     leaveTypeID: parseInt(formData.leaveTypeID, 10),
//     crDate: new Date().toISOString(),
//   };

//   console.log("Submitting leave:", finalPayload); // This will now print

//   const result = await applyLeave(finalPayload); //use it here
//   if (result) {
//     alert("✅ Leave applied successfully!");
//     setFormData({
//       employeeCode: sessionStorage.getItem("username") || "",
//       leaveTypeID: "",
//       startDate: "",
//       endDate: "",
//       reason: null,
//       crUser: sessionStorage.getItem("username") || "admin",
//       crDate: new Date().toISOString(),
//       deleted: "N",
//     });
//   }
// };

//   return (
//     <div className="container mt-4">
//       <h4 className="mb-3">Apply for Leave</h4>

//       <form onSubmit={handleSubmit} className="card p-3 shadow-sm">
//         {/* EmployeeCode is hidden but still sent */}
//         <input type="hidden" name="employeeCode" value={formData.employeeCode} />

//         <div className="mb-3">
//           <label>Leave Type </label>
//           <select
//             name="leaveTypeID"
//             className="form-control"
//             value={formData.leaveTypeID}
//             onChange={handleChange}
//             required
//           >
//             <option value="">-- Select Leave Type --</option>
//             {leaveTypes.map((leave) => (
//               <option key={leave.leaveTypeID} value={leave.leaveTypeID}>
//                 {leave.leaveName}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="mb-3">
//           <label>Start Date</label>
//           <input
//             type="date"
//             name="startDate"
//             className="form-control"
//             value={formData.startDate}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="mb-3">
//           <label>End Date</label>
//           <input
//             type="date"
//             name="endDate"
//             className="form-control"
//             value={formData.endDate}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="mb-3">
//           <label>Reason</label>
//           <textarea
//             name="reason"
//             className="form-control"
//             value={formData.reason}
//             onChange={handleChange}
            
//           ></textarea>
//         </div>

//         <button type="submit" className="btn btn-primary w-100">
//           Apply Leave
//         </button>
//       </form>
//     </div>
//   );
// };

// export default ApplyLeave;
